/**
 * @desc 初步检查能不能创建发货单，并获取包裹信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.checkOrderPackageDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/checkOrderPackageDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
